import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Menu } from 'lucide-react'
import { useLocale } from '../../i18n/LocaleContext'
import { navRoutes, getRegistrationPath } from '../../utils/routes'
import { getLocalizedPath, setPreferredLocale } from '../../utils/locale'
import MobileMenu from './MobileMenu'

export default function Header() {
  const { locale, t, otherLocale } = useLocale()
  const location = useLocation()
  const [mobileOpen, setMobileOpen] = useState(false)
  const routes = navRoutes[locale]

  function handleLocaleSwitch() {
    setPreferredLocale(otherLocale)
  }

  return (
    <>
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-border">
      <div className="container-max flex items-center justify-between h-16 md:h-20 px-4 md:px-8">
        {/* Logo */}
        <Link to={`/${locale}`} className="flex items-center" aria-label="Magic Harghita Adventures">
          <img
            src="/logo.jpg"
            alt="Magic Harghita Adventures"
            width={220}
            height={124}
            className="h-10 md:h-12 w-auto"
          />
        </Link>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {routes.map((route) => (
            <Link
              key={route.path}
              to={route.path}
              className={`text-sm font-body font-medium transition-colors hover:text-primary ${
                location.pathname === route.path
                  ? 'text-primary'
                  : 'text-text-secondary'
              }`}
            >
              {t.nav[route.labelKey]}
            </Link>
          ))}
        </nav>

        {/* Right side: language switcher + CTA */}
        <div className="hidden md:flex items-center gap-4">
          <Link
            to={getLocalizedPath(location.pathname, otherLocale)}
            onClick={handleLocaleSwitch}
            className="text-sm font-medium text-text-secondary hover:text-primary transition-colors px-2 py-1 border border-border rounded-btn"
          >
            {otherLocale.toUpperCase()}
          </Link>
          <Link
            to={getRegistrationPath(locale)}
            className="bg-primary text-white px-5 py-2.5 rounded-btn text-sm font-medium hover:bg-primary-hover transition-colors"
          >
            {t.nav.cta}
          </Link>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden p-2 text-secondary"
          onClick={() => setMobileOpen(true)}
          aria-label={locale === 'hu' ? 'Menü megnyitása' : 'Deschide meniul'}
          aria-expanded={mobileOpen}
          aria-controls="mobile-menu"
        >
          <Menu size={24} />
        </button>
      </div>

      </header>

      {/* Mobile menu overlay — rendered OUTSIDE <header> so its fixed-position
          backdrop/panel are sized to the viewport, not the header's box. The
          header's backdrop-blur would otherwise become the containing block and
          collapse the menu to the header's height (transparent-looking menu). */}
      <MobileMenu open={mobileOpen} onClose={() => setMobileOpen(false)} />
    </>
  )
}
